import { module } from 'stereomodularjs';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ResizeObserver from 'resize-observer-polyfill';

gsap.registerPlugin(ScrollTrigger);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.section = this.el.querySelector('.wp-block-stereo-section-bloc');
        this.sectionId = this.section.getAttribute('id');
        this.section.removeAttribute('id');
        this.el.setAttribute('id', this.sectionId);

        this.st1 = ScrollTrigger.create({
            trigger: this.section,
            start: 'bottom bottom',
            end: 'bottom+=10% top',
            pin: true,
            pinSpacing: false,
            scrub: 1,
            markers: false, // Mettre à true pour debug
        });

        this.st2 = ScrollTrigger.create({
            trigger: this.el,
            start: 'top top',
            end: 'bottom top',
            pin: false,
            scrub: 1,
            markers: false, // Mettre à true pour debug
            onEnter: () => {
                document.documentElement.classList.add('has-header-hidden');
            },
            onEnterBack: () => {
                document.documentElement.classList.add('has-header-hidden');
            },
            onLeave: () => {
                document.documentElement.classList.remove('has-header-hidden');
            },
            onLeaveBack: () => {
                document.documentElement.classList.remove('has-header-hidden');
            },
        });

        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 10);

        let resize_timeout;

        const resize_observer = new ResizeObserver(() => {
            clearTimeout(resize_timeout);
            resize_timeout = setTimeout(() => {
                ScrollTrigger.refresh();
            }, 11);
        });

        resize_observer.observe(document.querySelector('body'));
    }

    destroy() {
        this.st1.kill();
        this.st2.kill();
        this.section.setAttribute('id', this.sectionId);
        this.el.removeAttribute('id');
    }
}
